export async function createLog(eventName, params = {}, isCharged = false) {
    try {
        const cleverTap = window.clevertap;
        const dataLayer = window.dataLayer;
        console.log('the window', window.clevertap.getAccountID());
        console.log('the eventName', eventName, 'the params', params);

        let overrideObj = {};
        if (isCharged) {
            overrideObj = {
                Items: params.Items ? JSON.stringify(params.Items) : ''
            }
        }

        cleverTap.event.push(eventName, { ...params, ...overrideObj })
        if (eventName === 'Payment_Acknowledged') {
            dataLayer?.push({
                event: eventName,
                ecommerce: params
            })
        } else {
            dataLayer?.push({
                event: eventName,
                value: params
            })
        }
    }
    catch (e) {
        console.log('error createLog', e);
    }

}

export async function createRouteLog(previousRouteName, currentRouteName) {
    try {
        const cleverTap = window.clevertap;
        cleverTap.event.push(`navigated_to: ${currentRouteName}`)
    } catch (e) {
        console.log('error createRouteLog', e);
    }

}

// To set user by userId or client_UCID
export async function setUserObj(user) {
    try {
        const userObj = {
            "Site": user
        }
        const cleverTap = window.clevertap;
        const dataLayer = window.dataLayer;
        cleverTap.onUserLogin.push(userObj);
        console.log('the user>', userObj, 'user', user);
        dataLayer?.push({
            userId: user.Identity,
            event: 'setUserId',

        })
    } catch (e) {
        console.log('error setUserObj ', e);
    }

}